/**
 * Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: LicenseRef-.amazon.com.-AmznSL-1.0
 * Licensed under the Amazon Software License  http://aws.amazon.com/asl/
 */

import React from 'react';
import { Button, Header as BaseHeader, Modal, Grid } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { makeObservable, observable, action, runInAction } from 'mobx';

import { SecureOutput } from '../../models/secure-outputs/SecureOutput';
import { displayError, displaySuccess } from '../../helpers/notification';
import { getRejectSecureOutputEgressForm } from '../../models/forms/RejectSecureOutputEgressForm';
import TextArea from '../helpers/fields/TextArea';
import Toggle from '../helpers/fields/Toggle';

import Form from '../helpers/fields/Form';

class RejectEgress extends React.Component {
  modalOpen = false;
  reworkDisabled = false;	

  constructor(props) {
    super(props);
    makeObservable(this, {
      modalOpen: observable,
      reworkDisabled: observable,	    
    });

    this.secureOutput = props.secureOutput;
    this.permissionsStore = props.secureOutput.getPermissionsStore();
    this.cleanModal = this.cleanModal.bind(this);
    this.cleanModal();
  }

  cleanModal() {
    runInAction(() => {
      this.modalOpen = false;
    });
  }

  handleFormCancel = _form => {
    this.cleanModal();
  };

  handleFormError = (_form, _errors) => {};

  handleFormSubmission = async form => {
    try {
      const requestValues = form.values();

      await this.permissionsStore.rejectEgress(this.secureOutput.id, requestValues);
      this.secureOutput.updateStatus(SecureOutput.MY_REJECTED);

      displaySuccess('Egress request rejected.');
      this.cleanModal();
      if (this.props.onActionComplete) this.props.onActionComplete();	    
    } catch (error) {
      displayError(error);
    }
  };

  render() {
    const form = getRejectSecureOutputEgressForm();
    return (
      <Modal closeIcon trigger={this.renderTrigger()} open={this.modalOpen} onClose={this.cleanModal}>
        <div className="mt2 animated fadeIn">
          <BaseHeader as="h3" icon textAlign="center" className="mt3" color="grey">
            Reject Egress
          </BaseHeader>
          <div className="mx3 animated fadeIn">
            <Form
              form={form}
              onCancel={this.handleFormCancel}
              onSuccess={this.handleFormSubmission}
              onError={this.handleFormError}
            >
              {({ processing, _onSubmit, onCancel }) => {
		
                const reworkOnChange = action(data => {
                  if (data === true) {
                      form.$('allowRework').value = true;
                      this.reworkDisabled = false;
                  } else {
		      form.$('allowRework').value = false;	  
                      this.reworkDisabled = true;
                  }
                });
      
                return (
                  <>
	            <Grid>
	               <Grid.Column width={16}>		
		          <p>You may allow the requestor to make amendment to the egress request by togging on the &quot;Allow Rework&quot; option.<br/> By toggling the option, your requestor will be able to mount the secure-output to his/her workspace to perform the correction according to your comments.<br/>
			     E.g. The report contains columns A to E, but you cannot take out D and E. Please remove them from the report before resubmit egress request.
		          </p>
	               </Grid.Column>
                       <Grid.Column width={16}>
	                  <Toggle field={form.$('allowRework')} onChange={reworkOnChange} disabled={this.reworkDisabled} />		
                          <TextArea field={form.$('adminComments')} />	
                          <Button className="ml2 mb3" floated="right" color="blue" icon disabled={processing} type="submit">
                              Reject egress
                          </Button>
                          <Button className="mb3" floated="right" disabled={processing} onClick={onCancel}>
                              Cancel
                          </Button>
	               </Grid.Column>
	            </Grid>		
                  </>
                );
              }}
            </Form>
          </div>
        </div>
      </Modal>
    );
  }

  renderTrigger() {
    const props = this.props.buttonProps || {
      floated: 'right',
      size: 'mini',
      compact: true,
      color: 'blue',
    };
    return (
      <Button
        {...props}
        onClick={action(() => {
          this.modalOpen = true;
        })}
      >
        Reject egress
      </Button>
    );
  }
}

export default inject('userStore')(observer(RejectEgress));
